/**
 * App de marca (white label): NADA da Marçal pode aparecer (Pablo 2026-10-20: "cada marca é
 * uma identidade visual única, não pode aparecer nada da Marçal Contabilidade de jeito
 * nenhum"). As telas já usam o nome da marca onde foram ajustadas; isto é a rede que pega o
 * resto: texto de tela, texto vindo do servidor, aviso, título e texto de compartilhamento.
 */

/**
 * Marca guardada no aparelho, sem puxar o axios (este arquivo é usado por peças que
 * rodam fora do React, como o compartilhamento). Mesma chave de lib/marcaCliente.js.
 */
export function marcaGuardada() {
  try {
    const m = JSON.parse((typeof localStorage !== 'undefined' && localStorage.getItem('mc_wl_marca')) || 'null');
    return m && m.slug && m.tema ? m : null;
  } catch (_) { return null; }
}

// do mais longo pro mais curto (senão "Marçal" comeria "Marçal Contabilidade Ltda")
const TROCAS = [
  [/Cliente Marçal Contabilidade/gi, '{app}'],
  [/Meu Contador Marçal/gi, '{app}'],
  [/Marçal Contabilidade Ltda\.?/gi, '{app}'],
  [/Marcal Contabilidade Ltda\.?/gi, '{app}'],
  [/Marçal Contabilidade/gi, '{app}'],
  [/Marcal Contabilidade/gi, '{app}'],
  [/Marçal Assessoria/gi, '{app}'],
  [/equipe Marçal/gi, 'equipe {app}'],
  [/Cliente Marçal/gi, '{app}'],
  [/\bMeu Contador\b/g, '{app}'],
  [/Marçal/g, '{app}'],
  [/MARÇAL/g, '{APP}'],
  [/\bMarcal\b/g, '{app}'],
  [/\bThiago Borges\b/g, 'a equipe {app}'],
  [/CNPJ 36\.749\.464\/0001-42\s*·?\s*/g, ''],
  [/36\.749\.464\/0001-42/g, ''],
  [/[a-z0-9._-]+@marcalcontabilidade\.com\.br/gi, '{email}'],
  [/(https?:\/\/)?([a-z0-9-]+\.)*marcalcontabilidade\.com\.br/gi, ''],
  [/Curitiba\/PR/g, ''],
];

/** Tira a Marçal do texto (nome da marca no lugar). PURA. */
export function trocarMarcal(texto, marca) {
  if (!marca || typeof texto !== 'string' || !texto) return texto;
  if (!/mar[cç]al|meu contador|thiago borges|36\.749\.464|curitiba\/pr/i.test(texto)) return texto;
  const app = marca.nome_app || 'o app';
  const email = (marca.identidade && marca.identidade.suporte_email) || 'o suporte';
  let s = texto;
  for (const [re, por] of TROCAS) s = s.replace(re, por.replace('{app}', app).replace('{APP}', app.toUpperCase()).replace('{email}', email));
  return s.replace(/\s{2,}/g, ' ').replace(/\s+·\s*$/, '').replace(/^\s*·\s+/, '');
}

/** Link de WhatsApp de ajuda: número de suporte da marca (sem número: o link some). PURA. */
export function trocarLinkWhats(href, marca) {
  if (!marca || !/wa\.me\//i.test(String(href || ''))) return href;
  const d = String((marca.identidade && marca.identidade.suporte_whatsapp) || '').replace(/\D/g, '');
  if (!d) return null;
  const num = d.length <= 11 ? `55${d}` : d;
  return String(href).replace(/wa\.me\/(\d+)(\?text=([^\s"']*))?/i, (m0, n, q, txt) => {
    let t = '';
    if (txt) { try { t = `?text=${encodeURIComponent(trocarMarcal(decodeURIComponent(txt), marca))}`; } catch (_) { t = ''; } }
    return `wa.me/${num}${t}`;
  });
}

const ATRIBUTOS = ['alt', 'title', 'placeholder', 'aria-label'];

function _limparNo(no, marca) {
  if (no.nodeType === 3) {
    const v = no.nodeValue;
    const n = trocarMarcal(v, marca);
    if (n !== v) no.nodeValue = n;
    return;
  }
  if (no.nodeType !== 1) return;
  const tag = no.tagName;
  if (tag === 'SCRIPT' || tag === 'STYLE') return;
  for (const a of ATRIBUTOS) {
    if (no.hasAttribute && no.hasAttribute(a)) {
      const v = no.getAttribute(a); const n = trocarMarcal(v, marca);
      if (n !== v) no.setAttribute(a, n);
    }
  }
  // logo da Marçal num app de marca: some (a marca tem o seu)
  if (tag === 'IMG' && /marcal|marçal/i.test(no.getAttribute('src') || '')) no.style.display = 'none';
  if (tag === 'A') {
    const h = no.getAttribute('href') || '';
    if (/marcalcontabilidade\.com\.br/i.test(h)) no.removeAttribute('href');
    else if (/wa\.me\//i.test(h)) { const n = trocarLinkWhats(h, marca); if (n === null) no.removeAttribute('href'); else if (n !== h) no.setAttribute('href', n); }
  }
  if (tag === 'INPUT' || tag === 'TEXTAREA') return; // não mexe no que a pessoa digita
  for (const f of no.childNodes) _limparNo(f, marca);
}

/**
 * Observa um pedaço da tela e tira a Marçal de tudo que aparecer nele.
 * Devolve a função que para de observar.
 */
export function vigiarSemMarcal(raiz, marca) {
  if (!raiz || !marca || typeof MutationObserver === 'undefined') return () => {};
  _limparNo(raiz, marca);
  if (typeof document !== 'undefined') document.title = trocarMarcal(document.title, marca);
  const obs = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === 'characterData') _limparNo(m.target, marca);
      else if (m.type === 'attributes') _limparNo(m.target, marca);
      else m.addedNodes.forEach((n) => _limparNo(n, marca));
    }
    if (typeof document !== 'undefined') { const t = trocarMarcal(document.title, marca); if (t !== document.title) document.title = t; }
  });
  obs.observe(raiz, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ATRIBUTOS.concat(['src', 'href']) });
  return () => obs.disconnect();
}
